
<template>
  <div class="bind-usdt">
    <div class="card-box">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: bold">{{
            $t("RewardCenter.BindUSDTAcc.Title")
          }}</span>
        </div>
        <div class="tip-box">
          <div>{{ $t("RewardCenter.BindUSDTAcc.Tip") }}</div>
        </div>
        <div class="contents-box">
          <el-row :gutter="20" style="line-height: 2">
            <el-col :span="10">
              <div class="lb">{{ $t("RewardCenter.BindUSDTAcc.Address") }}</div>
            </el-col>
            <el-col :span="12">
              <div class="inp">
                <CInput
                  v-model="bindObj.USDT.Address"
                  oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
                  type="text"
                  :invalid-feedback="errorBackAddress"
                  :is-valid="validatorAddress"
                  valid-feedback=""
                />
              </div>
            </el-col>
          </el-row>
          <div style="margin-top: 1rem">
            <button
              @click="submitUSDTAcc"
              class="btn custer sbtn"
              type="button"
            >
              {{ $t("RewardCenter.TransferToAcc.TransferConfirm") }}
            </button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
export default {
  data() {
    return {
      bindObj: {
        USDT: {
          Address: "",
        },
      },
      errorBackAddress: "",
      flags: false,
    };
  },
  methods: {
    validatorAddress(val) {
      let reg = /^T.*/;
      if (val === "") {
        this.errorBackAddress = "";
        this.flags = false;
        return;
      }
      if (reg.test(val)) {
        this.errorBackAddress = "";
        this.flags = false;
        return true;
      } else {
        this.errorBackAddress = this.$t(
          "RewardCenter.BindUSDTAcc.InvalidAddress"
        );
        this.flags = true;
        return false;
      }
    },
    // 提交USDT账户绑定
    submitUSDTAcc() {
      if (this.bindObj.USDT.Address == "" || this.flags == true) {
        return;
      }
      let loading = Loading.service({ fullscreen: true });
      this.$axios({
        method: "POST",
        url: `/request/user.php?type=bind_agent_withdraw_acc&uid=${localStorage.getItem(
          "uid"
        )}`,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        data: JSON.stringify(this.bindObj),
      }).then((res) => {
        if (res.data.code == 200) {
          loading.close();
          this.$message.success(res.data.message);
          this.$router.push("/reward-center/account");
        } else if (res.data.code == 401) {
          loading.close();
          this.$message.warning(res.data.message);
          this.$router.push("/pages/login");
        } else {
          loading.close();
          this.$message({
            type: "error",
            message: res.data.message,
            duration: 5000,
          });
        }
      });
    },
  },
};
</script>


<style scoped>
.bind-usdt {
  padding-left: 2.6rem;
}
.card-box {
  width: 83%;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.contents-box {
  width: 420px;
  margin: 1rem auto;
}
.citem {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.form-group {
  margin: 0;
}
.lb {
  text-align: right;
  color: rgb(66, 71, 77);
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.inp {
  margin-left: 30px;
  margin-bottom: 0.88rem;
}
.tip-box {
  padding: 10px 20px;
  background: #fdf6ec;
  color: #e6aa6f;
  text-align: center;
  font-size: 14px;
}
.sbtn:hover {
  background: rgba(0, 190, 164, 0.8) !important;
}
.sbtn:focus {
  border-color: #00bea4;
  box-shadow: 0 0 0 0.25rem rgba(0, 190, 164, 0.5) !important;
}
.custer {
  background: #00bea4;
  color: #fff;
  width: 100%;
  outline: 0;
}
</style>